document.addEventListener("DOMContentLoaded", () => {
  // $('.featured_post-slider').slick({
  //   autoplay:true,
  //   autoplaySpeed:4000,
  //   arrows:true,
  //   infinite:true,
  //   dots:true
  // });
  const slider = document.querySelector(".promotion-jwt");

  // Duplicate content for seamless loop
  const clone = slider.innerHTML;
  slider.innerHTML = `<div class="promotion-track">${clone + clone}</div>`;
  const track = slider.querySelector(".promotion-track");

  // Calculate width of items
  const totalWidth = track.scrollWidth / 2;
  const speed = 80; // Slower speed
  const duration = totalWidth / speed;

  // Apply animation
  track.style.animationName = "promo-scroll";
  track.style.animationDuration = `${duration}s`;

  // Add keyframes dynamically
  const styleSheet = document.createElement("style");
  styleSheet.innerHTML = `
    @keyframes promo-scroll {
      0% { transform: translateX(0); }
      100% { transform: translateX(-${totalWidth}px); }
    }
  `;
  document.head.appendChild(styleSheet);

  // Pause on hover
  slider.addEventListener("mouseenter", () => track.classList.add("paused"));
  slider.addEventListener("mouseleave", () => track.classList.remove("paused"));

  /* video section */
  document.querySelectorAll(".video-container").forEach(container => {
    try {
      const video = container.querySelector("video");
      const btn = container.querySelector(".wt-video__sound-toggle");
      const iconOn = btn.querySelector(".svg-icon--volume");
      const iconOff = btn.querySelector(".svg-icon--volume-muted");

      // Initialize icon based on video state
      btn.setAttribute('data-sound', video.muted ? 'off' : 'on');
      iconOn.style.display = video.muted ? 'none' : 'inline';
      iconOff.style.display = video.muted ? 'inline' : 'none';

      btn.addEventListener("click", () => {
        video.muted = !video.muted;
        btn.setAttribute('data-sound', video.muted ? 'off' : 'on');
        iconOn.style.display = video.muted ? 'none' : 'inline';
        iconOff.style.display = video.muted ? 'inline' : 'none';
      });
    } catch (error) {
      
    }
    
  });
  /* end video section */

  // if ($(window).width() > 1280) {
  //   var width = $(".video-container").width(); 
  //   var halfWidth = width / 2;                
  //   // $(".section_video--reels .swiper").css("padding-right", halfWidth + "px");
  //   // $('.section_video--reels .product-card__image-wrapper').css('transform', `translateX(-${halfWidth/2}px)`);
  //    $('.center_title_wrap').css({
  //       'transform': `translateX(-${halfWidth / 2}px)`,
  //       'width': width + "px"
  //   });
  // }

  $('.mega-menu__list').on('mouseenter', '[data-target]', function () {
    const $this = $(this);
    const targetClass = $this.data('target');
    const $wrap = $this.closest('.mega-menu__list');

    $wrap.find('.mega-menu__item').hide();
    $wrap.find('.' + targetClass).show();
    $wrap.closest('.mega-menu__wrapper').find('.mega-menu__promotions').addClass('hidden');
    const $target = $wrap.closest('.mega-menu__wrapper').find('.' + targetClass);

    if ($target.length) {
      $target.removeClass('hidden');
    }
    $wrap.find('[data-target]').removeClass('active');
    $this.addClass('active');
  });

});



$(document).on('click', '.swipe_on_mobile_dot', function () {
  const $el = $(this);
  const index = $el.data('index');
  const $wrapper = $el.closest('.section--custom-content');
  const $slider = $wrapper.find('.section__content');
  const width = $slider.find('.f-column').outerWidth(true);

  $wrapper.find('.swipe_on_mobile_dot').removeClass('active');
  $el.addClass('active');

  $slider[0].scrollTo({
    left: width * index,
    behavior: 'smooth'
  });
});


$('.dot_enable_container .section__content').on('scroll', function () {
  const $container = $(this);
  const $wrapper = $container.closest('.dot_enable_container');
  const $dots = $wrapper.find(".swipe_on_mobile_dot");
  clearTimeout($container.data('scrollTimeout'));
  $container.data('scrollTimeout', setTimeout(() => {
    const $slides = $container.find('.custom-content-block--image_card');
    const scrollLeft = $container.scrollLeft();
    let activeIndex = 0;
    $slides.each(function (i) {
      const slideLeft = $(this).position().left;
      if (slideLeft - scrollLeft <= 1) { 
        activeIndex = i;
      }
    });
    $dots.removeClass('active').eq(activeIndex).addClass('active');
  }, 0));
});


function setGridImageHeight() {
  let maxHeight = 0;
  $(".product-card__image-wrapper").each(function () {
    let h = $(this).outerHeight();
    if (h > maxHeight) {
      maxHeight = h;
    }
  });
  $(".grid_1_image").height(maxHeight);
}

$(window).on("load resize", function () {
  setGridImageHeight();
  // $('.slick--slider').slick({
  //   infinite: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   responsive: [
  //     {
  //       breakpoint: 768, // below 768px (phone/tablet)
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //         dots:true
  //       }
  //     },
  //     {
  //       breakpoint: 480, // optional: very small phones
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //         dots:true
  //       }
  //     }
  //   ]
  // });
});



$(document).on("click", ".tag-filters__item a", function (e) {
    e.preventDefault();
    $(".tag-filters-wrapper .tag-filters__item").removeClass("active");
    $(this).parents("li").addClass("active");
    const tagName = $(this).parents("li").attr("id");
    console.log("tagName ", tagName);
    if (tagName != "all") {
      $(".products-list .f-column").hide();
      $(`.products-list .f-column.${tagName}`).show();
    } else {
      $(".products-list .f-column").show();
    }
});

if (window.jQuery && $.fn.slick && $('.coffrets-iwt-items').length) {
  $('.coffrets-iwt-items').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,

    responsive: [
      {
        breakpoint: 1024, // tablet
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768, // small tablet / large mobile
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480, // mobile
        settings: {
          slidesToShow: 2,
          arrows: false,   // optional (mobile pe arrows hata do)
          dots: true       // dots show karo
        }
      }
    ]
  });
}


function setHeightFromFirst() {
  var h = $('.grid__height').height();
  $('.grid__item--video').height(h);
  $('.grid__item--video img').height(h);
}

$(window).on('load resize', setHeightFromFirst);


$(document).ready(function () {
  $(".read_less").css("display", "none");
  $(".hide_text").css("display", "none");
  $(".read_more").on("click", function () {
    let parent = $(this).closest("h2");
    parent.find(".hide_text").css("display", "inline");
    parent.find(".read_less").css("display", "inline");
    $(this).css("display", "none");
  });
  $(".read_less").on("click", function () {
    let parent = $(this).closest("h2");
    parent.find(".hide_text").css("display", "none");
    parent.find(".read_more").css("display", "inline");
    $(this).css("display", "none");
  });

});

$(document).on('click', '.lang_cnvtr', function (e) {
  e.preventDefault();
  let v = $(this).attr('data-value');
  $('[name="locale_code"]').val(v)
  $(this).closest('form').submit()
});


document.addEventListener('cart:updated', async () => {
  try {

    const response = await fetch('/?section_id=cart-drawer');
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const updatedBar = doc.querySelector('#custom-shipping--bar');
    const currentBar = document.querySelector('#custom-shipping--bar');

    if (updatedBar && currentBar) {
      currentBar.replaceWith(updatedBar);
    }

  } catch (err) {
    console.error(err);
  }
});

$(window).on('load', function () {
  if ($(window).width() <= 992) {
    if (window.jQuery && $.fn.slick && $('.feature-list__items').length) {
      $('.feature-list__items').slick({
        infinite: true,
        variableWidth: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        swipe: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 500,
        pauseOnHover: true,
        pauseOnFocus: false
      });
    }
  }
});


// document.addEventListener("DOMContentLoaded", function () {
//   const elements = document.querySelectorAll(".collection-description-expend .rich-text__text");

//   elements.forEach((el) => {
//     const fullText = el.innerHTML;
//     const words = fullText.split(" ");
//     const limit = 30;

//     if (words.length > limit) {
//       const shortText = words.slice(0, limit).join(" ");

//       el.innerHTML = `
//         <span class="short-text">${shortText}...</span>
//         <span class="full-text" style="display:none;">${fullText}</span>
//         <a href="#" class="read-more-btn"> Read More</a>
//       `;

//       const btn = el.querySelector(".read-more-btn");
//       const shortSpan = el.querySelector(".short-text");
//       const fullSpan = el.querySelector(".full-text");

//       btn.addEventListener("click", function (e) {
//         e.preventDefault();

//         if (fullSpan.style.display === "none") {
//           fullSpan.style.display = "inline";
//           shortSpan.style.display = "none";
//           btn.textContent = " Read Less";
//         } else {
//           fullSpan.style.display = "none";
//           shortSpan.style.display = "inline";
//           btn.textContent = " Read More";
//         }
//       });
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(
    ".collection-description-expend .rich-text__text"
  );
  elements.forEach((el) => {
    const fullHTML = el.innerHTML;
    const fullText = el.textContent.trim();
    const words = fullText.split(" ");
    const limit = 20;
    if (words.length > limit) {
      const shortText = words.slice(0, limit).join(" ");
      el.innerHTML = `
        <span class="short-text">${shortText}...</span>
        <span class="full-text" style="display:none;">
          ${fullHTML}
        </span>
        <a href="javascript:void(0)" class="read-more-btn">
          Lire la suite
        </a>
      `;
      const btn = el.querySelector(".read-more-btn");
      const shortSpan = el.querySelector(".short-text");
      const fullSpan = el.querySelector(".full-text");

      btn.addEventListener("click", function () {

        if (fullSpan.style.display === "none") {

          fullSpan.style.display = "inline";
          shortSpan.style.display = "none";
          btn.textContent = "Lire moins";

        } else {

          fullSpan.style.display = "none";
          shortSpan.style.display = "inline";
          btn.textContent = "Lire la suite";
        }
      });
    }

  });


document.querySelectorAll('.read_more-btn').forEach((btn) => {
  btn.addEventListener('click', function () {
    const content = this.previousElementSibling;
    content.classList.toggle('active');
    if (content.classList.contains('active')) {
      this.textContent = 'Lire moins';
    } else {
      this.textContent = '...Lire la suite';
    }
  });

});
});


let maxHeight = 0;

$('.product-card__info').each(function () {
  maxHeight = Math.max(maxHeight, $(this).height());
});

if (!$('body').hasClass('search-template')) {
    $('.products-list .product-card__info').height(maxHeight);
}



const equalizeHeight = selectors => {
  selectors.forEach(selector => {
    const items = document.querySelectorAll(selector);

    if (!items.length) return;

    items.forEach(el => (el.style.height = 'auto'));

    const maxHeight = Math.max(...Array.from(items, el => el.offsetHeight));

    items.forEach(el => (el.style.height = `${maxHeight}px`));
  });
};

let resizeTimer;

const selectors = [
  '.testimonial__footer a.testimonial__product',
  '.custom-home-card-images .card-media .card-media__content .card-media__heading',
  '.custom-home-card-images.card-images .card-media__content-wrapper'
];

const runEqualize = () =>
  requestAnimationFrame(() => equalizeHeight(selectors));

document.addEventListener('DOMContentLoaded', runEqualize);

window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(runEqualize, 200);
});


$(document).on('click', '.mobile-sticky-bar__link', function () {
    const $cartDrawer = $('cart-drawer');
    const $searchDrawer = $('search-drawer');

    if ($cartDrawer.is('[open]') || $searchDrawer.is('[open]')) {
        console.log('both drawers are open');

        const menuDrawer = document.querySelector('menu-drawer');
        if (menuDrawer) {
            menuDrawer.removeAttribute('open');
        }
    }
});

// bundle all prices

var totalCents = 0;
var $btn_html = $('.bundle-atc-btn');

$('.products-bundle-section .product-bundle-card').each(function () {
    totalCents += parseInt(
        $(this).find('option:selected').data('price')
    ) || 0;
});

var formattedPrice =
    (totalCents / 100).toFixed(2).replace('.', ',') + '€';

// console.log(formattedPrice);
$btn_html.append(`<span>- ${formattedPrice}</span>`);

$(document).on('click', '.btn-cart_related_product', function () {
    var $btn = $(this);
    var variantId = $btn.data('variant-id');
    if (!variantId || $btn.is(':disabled')) return;
    $btn.prop('disabled', true).addClass('btn--loading');
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            id: variantId,
            quantity: 1
        },
        success: function (response) {
            console.log('Added to cart', response);
            window.RefreshCartPage();
            window.onCartUpadate();
         
        },
        error: function (xhr) {
            console.log(xhr.responseJSON);
        },
        complete: function () {
            $btn.prop('disabled', false).removeClass('btn--loading');
        }
    });
});


// document.addEventListener('click', function (e) {
//   const trigger = e.target.closest('[data-m_html]');
//   if (trigger) {
//     const modal = document.querySelector('.speech-card-modal');
//     if (!modal) return;

//     const content = modal.querySelector('.speech-inner--js');
//     if (!content) return;

//     const html = trigger.getAttribute('data-m_html');
//     content.innerHTML = html || '';

//     modal.classList.add('active', 'loading');

//     const media = content.querySelectorAll('img,video');

//     if (!media.length) {
//       modal.classList.remove('loading');
//       return;
//     }

//     let loaded = 0;
//     const done = () => {
//       if (++loaded === media.length) {
//         modal.classList.remove('loading');
//       }
//     };

//     media.forEach(el => {
//       if (el.tagName === 'IMG') {
//         if (el.complete) done();
//         else {
//           el.addEventListener('load', done, { once: true });
//           el.addEventListener('error', done, { once: true });
//         }
//       } else {
//         if (el.readyState >= 3) done();
//         else {
//           el.addEventListener('loadeddata', done, { once: true });
//           el.addEventListener('error', done, { once: true });
//         }
//       }
//     });

//     return;
//   }

//   const close = e.target.closest('.speech-card-modal-close');
//   if (close) {
//     close.closest('.speech-card-modal')?.classList.remove('active', 'loading');
//   }
// });

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-m_html]');
  if (trigger) {
    console.group('Modal Open');

    console.log('Trigger:', trigger);
    console.log('data-m_html:', trigger.dataset.mHtml);

    const modal = document.querySelector('.speech-card-modal');
    console.log('Modal:', modal);

    if (!modal) {
      console.error('Modal not found');
      console.groupEnd();
      return;
    }

    const content = modal.querySelector('.speech-inner--js');
    console.log('Content:', content);

    if (!content) {
      console.error('.speech-inner--js not found');
      console.groupEnd();
      return;
    }

    const html = trigger.getAttribute('data-m_html');
    console.log('data-m_html:', html);
    content.innerHTML = html || '';
    console.log('HTML inserted');

    modal.classList.add('active', 'loading');
    console.log('Classes:', modal.className);

    const media = content.querySelectorAll('img,video');
    console.log('Media found:', media.length);

    if (!media.length) {
      console.log('No media, removing loading');
      modal.classList.remove('loading');
      console.groupEnd();
      return;
    }

    let loaded = 0;
    const done = () => {
      loaded++;
      console.log(`Loaded ${loaded}/${media.length}`);

      if (loaded === media.length) {
        console.log('All media loaded');
        modal.classList.remove('loading');
        console.groupEnd();
      }
    };

    media.forEach(el => {
      console.log('Checking:', el.tagName, el.src || el.currentSrc);

      if (el.tagName === 'IMG') {
        if (el.complete) {
          console.log('Image already loaded');
          done();
        } else {
          el.addEventListener('load', () => {
            console.log('Image load event');
            done();
          }, { once: true });

          el.addEventListener('error', () => {
            console.log('Image error');
            done();
          }, { once: true });
        }
      } else {
        if (el.readyState >= 3) {
          console.log('Video already loaded');
          done();
        } else {
          el.addEventListener('loadeddata', () => {
            console.log('Video loaded');
            done();
          }, { once: true });

          el.addEventListener('error', () => {
            console.log('Video error');
            done();
          }, { once: true });
        }
      }
    });

    return;
  }

  const close = e.target.closest('.speech-card-modal-close');
  if (close) {
    console.log('Modal closed');
    close.closest('.speech-card-modal')?.classList.remove('active', 'loading');
  }
});


// const items = document.querySelectorAll('.grid__height');
// if (items.length) {
//   const minHeight = Math.min(
//     ...Array.from(items).map(item => item.offsetHeight)
//   );

//   console.log('Minimum height:', minHeight);
//   $('.products-list .colection__card-grid').height(minHeight);
// }

function setMinHeight() {
  const items = document.querySelectorAll('.grid__height');

  if (items.length) {
    const minHeight = Math.min(
      ...Array.from(items).map(item => item.offsetHeight)
    );

    console.log('Minimum height:', minHeight);
    $('.products-list .colection__card-grid').height(minHeight);
  }
}

$(window).on('resize', function () {
  setTimeout(function () {
    setMinHeight();
  }, 300);
});

// Initial load
setMinHeight();

$(document).on('mouseenter', '.highlight_img-target', function () {
  var $target = $(this);
  var target = $target.attr('data-target');
  var $wrap = $target.closest('.highlight-text-with-image');
  var wrap = $wrap[0];

  // Show only the matching media
  $wrap.find('.heighlight__media, .htwi__open').each(function () {
    var $el = $(this);
    var isMatch = $el.attr('data-media') === target;

    $el.attr('hidden', !isMatch);

    if ($el.hasClass('heighlight__media')) {
      var video = $el.find('.high_card__video-modal video')[0];

      if (video) {
        if (isMatch) {
          video.muted = true;

          var playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    }
  });

  /*
   * Calculate reveal origin from the hovered target
   */
  var sectionRect = wrap.getBoundingClientRect();
  var targetRect = this.getBoundingClientRect();

  var x =
    (
      (targetRect.left + targetRect.width / 2 - sectionRect.left) /
      sectionRect.width *
      100
    ).toFixed(1) + '%';

  var y =
    (
      (targetRect.top + targetRect.height / 2 - sectionRect.top) /
      sectionRect.height *
      100
    ).toFixed(1) + '%';

  console.log(targetRect, 'targetRect');
  console.log('Reveal position:', x, y);

  /*
   * If animation is currently closed,
   * set the origin BEFORE opening it.
   */
  if (!$wrap.hasClass('highlight-active')) {
    var $layer = $wrap.find('.highlight__layer');

    if ($layer.length) {
      $layer[0].style.transition = 'none';
    }

    wrap.style.setProperty('--x', x);
    wrap.style.setProperty('--y', y);

    /*
     * Force browser reflow.
     * This makes sure the new --x / --y position
     * is applied before the reveal animation starts.
     */
    wrap.offsetHeight;

    if ($layer.length) {
      $layer[0].style.transition = '';
    }
  } else {
    // If already open, simply update the origin.
    wrap.style.setProperty('--x', x);
    wrap.style.setProperty('--y', y);
  }

  /*
   * Start circular reveal
   */
  $wrap.addClass('highlight-active');
});


/*
 * Close / reverse circular reveal
 */


$(document).on('mouseleave', '.highlight-text-with-image', function () {
  var $wrap = $(this);
  var wrap = this;
  var layer = $wrap.find('.highlight__layer')[0];

  if (!layer || !$wrap.hasClass('highlight-active')) return;

  // Already animating: if it was re-opening, flip it back to closing
  var existing = $wrap.data('closeAnim');
  if (existing) {
    if (existing.playbackRate < 0) existing.reverse();
    return;
  }

  // Use the SAME center that was used to open (hovered word)
  var cs = getComputedStyle(wrap);
  var cx = cs.getPropertyValue('--x').trim() || '50%';
  var cy = cs.getPropertyValue('--y').trim() || '50%';

  // Start from the current visible shape, so nothing jumps
  // (works even if the mouse leaves while the zoom-in is still running)
  var from = getComputedStyle(layer).clipPath;
  if (!from || from === 'none') {
    from = 'circle(142% at ' + cx + ' ' + cy + ')';
  }

  var anim = layer.animate(
    [
      { clipPath: from },
      { clipPath: 'circle(0% at ' + cx + ' ' + cy + ')' }
    ],
    { duration: 800, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' }
  );

  $wrap.data('closeAnim', anim);

  anim.onfinish = function () {
    $wrap.data('closeAnim', null);

    if (anim.playbackRate < 0) {
      anim.cancel();
      return;
    }

    layer.style.transition = 'none';
    $wrap.removeClass('highlight-active');
    anim.cancel();
    layer.offsetHeight; // force reflow
    layer.style.transition = '';

    $(layer).find('.heighlight__media, .htwi__open').attr('hidden', true);

    $(layer).find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });
  };
});

$(document).on('click', '.high__close', function () {
  console.log('high__close>>>>>>>>');
  var $wrap = $(this).closest('.highlight-text-with-image');
  var wrap = $wrap[0];
  var layer = $wrap.find('.highlight__layer')[0];

  if (!layer || !$wrap.hasClass('highlight-active')) return;

  var existing = $wrap.data('closeAnim');

  if (existing) {
    if (existing.playbackRate < 0) existing.reverse();
    return;
  }

  // Same center that was used to open
  var cs = getComputedStyle(wrap);
  var cx = cs.getPropertyValue('--x').trim() || '50%';
  var cy = cs.getPropertyValue('--y').trim() || '50%';

  // Start from current visible shape
  var from = getComputedStyle(layer).clipPath;

  if (!from || from === 'none') {
    from = 'circle(142% at ' + cx + ' ' + cy + ')';
  }

  var anim = layer.animate(
    [
      { clipPath: from },
      { clipPath: 'circle(0% at ' + cx + ' ' + cy + ')' }
    ],
    {
      duration: 800,
      easing: 'cubic-bezier(0.65, 0, 0.35, 1)',
      fill: 'forwards'
    }
  );

  $wrap.data('closeAnim', anim);

  anim.onfinish = function () {
    $wrap.data('closeAnim', null);

    if (anim.playbackRate < 0) {
      anim.cancel();
      return;
    }

    layer.style.transition = 'none';

    $wrap.removeClass('highlight-active');

    anim.cancel();

    layer.offsetHeight;

    layer.style.transition = '';

    $(layer)
      .find('.heighlight__media, .htwi__open')
      .attr('hidden', true);

    $(layer).find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });
  };
});

// $(document).on('mouseleave', '.highlight-text-with-image', function () {
//   var $wrap = $(this);

//   $wrap.removeClass('highlight-active');

//   /*
//    * Hide media
//    */
//   $wrap
//     .find('.heighlight__media, .htwi__open')
//     .attr('hidden', true);

//   /*
//    * Stop all videos
//    */
//   $wrap.find('.high_card__video-modal video').each(function () {
//     this.pause();
//     this.currentTime = 0;
//   });
// });


$(document).ready(function () {
  setTimeout(function(){
    $('body').removeClass('loader');
  },3000);
});



var removeSampleItemss = (productIDS, callValidateFreeItem = "false") => {
  if (productIDS.length) {
    let formData = {
      updates: {},
    };

    var productID;
    for (productID in productIDS) {
      var id = productIDS[productID]?.split("|")[0];
      var qty = productIDS[productID]?.split("|")[1];
      formData["updates"][parseInt(id)] = qty;
    }
    console.log(formData);

    let info = fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (callValidateFreeItem === "true") {
          validateFreeItems();
        } else {
           if(location.pathname == '/cart'){
        window.location.reload();
    }
            window.RefreshCartPage();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};

var validateFreeItems = () => {
  console.log("Call validateFreeItem");
  if (
    Shopify.settings.afwp_enable === "true" &&
    Shopify.settings.afwp_product != ""
  ) {
    setTimeout(function () {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
      })
        .done(function (cart, textStatus, jqXHR) {
          var afwp_threshold_1 = Shopify.settings.afwp_threshold_1,
            afwp_threshold_2 = Shopify.settings.afwp_threshold_2,
            afwp_threshold_3 = Shopify.settings.afwp_threshold_3,
            afwp_threshold_4 = Shopify.settings.afwp_threshold_4,
            afwp_avail_qty_1 = Shopify.settings.afwp_avail_qty_1,
            afwp_avail_qty_2 = Shopify.settings.afwp_avail_qty_2,
            afwp_avail_qty_3 = Shopify.settings.afwp_avail_qty_3,
            afwp_avail_qty_4 = Shopify.settings.afwp_avail_qty_4,
            afwp_id = Shopify.settings.afwp_product,
            cart_total_price,
            threshold_qty = 0;
          if (Shopify.afwp_variants.id.length) {
            cart_total_price = getCartValueById(
              cart,
              Shopify.afwp_variants.id,
              "price"
            );
          } else {
            cart_total_price = cart.total_price;
          }
          console.log(cart_total_price);
          if (
            cart_total_price > afwp_threshold_1 &&
            cart_total_price < afwp_threshold_2 &&
            cart_total_price < afwp_threshold_3 &&
            cart_total_price < afwp_threshold_4
          ) {
            threshold_qty = afwp_avail_qty_1;
          } else if (
            cart_total_price > afwp_threshold_1 &&
            cart_total_price > afwp_threshold_2 &&
            cart_total_price < afwp_threshold_3 &&
            cart_total_price < afwp_threshold_4
          ) {
            threshold_qty = afwp_avail_qty_2;
          } else if (
            cart_total_price > afwp_threshold_1 &&
            cart_total_price > afwp_threshold_2 &&
            cart_total_price > afwp_threshold_3 &&
            cart_total_price < afwp_threshold_4
          ) {
            threshold_qty = afwp_avail_qty_3;
          } else if (
            cart_total_price > afwp_threshold_1 &&
            cart_total_price > afwp_threshold_2 &&
            cart_total_price > afwp_threshold_3 &&
            cart_total_price > afwp_threshold_4
          ) {
            threshold_qty = afwp_avail_qty_4;
          }

          var giftKeyFromCart = [],
            gift_count = 0;
          cart.items.forEach((item) => {
            try {
              if (item.properties["__type"] != null) {
                if (item.properties["__type"] === "free gift") {
                  gift_count = gift_count + item.quantity;
                }
              }
            } catch (err) {
              console.log(err);
            }
          });

          var checkItem = checkItemInCart(cart);
          console.log(checkItem);
          if (threshold_qty > 0 && checkItem) {
            if (gift_count > 0) {
              cart.items.forEach((item) => {
                if (item.properties["__type"] != null) {
                  if (item.properties["__type"] === "free gift") {
                    var quantity = threshold_qty,
                      item_key = item.key;
                    giftKeyFromCart.push(item_key + "|" + quantity);
                  }
                }
              });
              removeSampleItemss(giftKeyFromCart);
            } else {
              var data = {
                quantity: threshold_qty,
                id: afwp_id,
                properties: { __type: "free gift" },
              };
              addItemToCart(data);
            }
          } else {
            if (cart.items.length) {
              cart.items.forEach((item) => {
                if (item.properties["__type"] != null) {
                  if (item.properties["__type"] === "free gift") {
                    var quantity = 0,
                      item_key = item.key;
                    giftKeyFromCart.push(item_key + "|" + quantity);
                  }
                }
              });
              removeSampleItemss(giftKeyFromCart);
            }
          }
          return "success";
        })
        .fail(function (jqXHR, textStatus) {});
    }, 1000);
  } else {
     window.RefreshCartPage();
  }
};
function addItemToCart(data) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: data,
    success: function (data) {
        if(location.pathname == '/cart'){
        window.location.reload();
    }
      window.refreshCart();
    },
    error: function (status) {
      console.log(status);
      console.log($.parseJSON(status.responseText).description);
      $(".selectFreeGift").prop("disabled", false);
    },
  });
}
// window.onCartUpadate = () => {
//     console.log("call window.onCartUpadate");
//     validateFreeItems();
// };
$(document).ready(function () {
    validateFreeItems();
});